// extracted by mini-css-extract-plugin
export default {"cover_section":"perfil-cover_cover_section__kDj0w","coverImg":"perfil-cover_coverImg__YWYBR"};